export default __webpack_public_path__ + "static/media/15.04573b22.png";